// src/firebase/firebaseConfig.js
import { initializeApp, getApps } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  GithubAuthProvider,
  TwitterAuthProvider
} from 'firebase/auth';
import { getDatabase } from 'firebase/database';

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyD_2FLh1f_BJyKdzeqMvF-oB9Av2cLG6ps",
  authDomain: "reactify-61b82.firebaseapp.com",
  databaseURL: "https://reactify-61b82.firebaseio.com",
  projectId: "reactify-61b82",
  storageBucket: "",
  messagingSenderId: "598228895769"
};

// Initialize app only if not already initialized
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

// Auth and Providers
const auth = getAuth(app);
const googleAuthProvider = new GoogleAuthProvider();
const facebookAuthProvider = new FacebookAuthProvider();
const githubAuthProvider = new GithubAuthProvider();
const twitterAuthProvider = new TwitterAuthProvider();
const database = getDatabase(app);

export {
  auth,
  googleAuthProvider,
  facebookAuthProvider,
  githubAuthProvider,
  twitterAuthProvider,
  database
};
